import { FC } from 'react';
import './DashboardTableEmpty.scss';
import { useTranslation } from 'react-i18next';

export const DashboardTableEmpty: FC = () => {
  const { t } = useTranslation();

  return <div className="DashboardTableEmpty">{t('There are no such assets.')}</div>;
};
